export default __webpack_public_path__ + "static/media/a2m.3e91a083.png";